import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScScratchGamePage = styled.div`
  position: relative;
`;

export const ScContainerMain = styled.div`
  position: relative;
  margin-bottom: 30px;
  z-index: 3;

  @media (${device.mobile}) {
    margin-bottom: 32px;
  }
`;

export const ScScratchGamePageTitle = styled.h1`
  max-width: 544px;
  margin: 0 auto 16px;
  ${typography['headline1']}
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
  text-transform: uppercase;

  @media (${device.mobile}) {
    ${typography['headline2']}
  }
`;
